import { render, staticRenderFns } from "./NoveltyResult.vue?vue&type=template&id=e7d4541a&lang=pug&"
import script from "./NoveltyResult.vue?vue&type=script&lang=js&"
export * from "./NoveltyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports